import { siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                菲菲影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              菲菲影院提供电视剧全集免费在线观看，最新热播剧高清不缓冲，海量剧集在线看，流畅体验满足连续追剧需求。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-400 hover:text-primary-400 hover:bg-background-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-400 hover:text-primary-400 hover:bg-background-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-400 hover:text-primary-400 hover:bg-background-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}>热播剧集</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}>热度榜单</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>剧集索引</a>
              <a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}>关于菲菲</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门题材</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>国产剧专区</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>韩剧馆</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>美剧频道</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>动漫番剧</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">优质合作伙伴持续加入中</p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 菲菲影院网 版权所有 | 电视剧全集免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer no-underline">服务条款</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer no-underline">隐私政策</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer no-underline" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}